module.exports = __webpack_public_path__ + "img/legs_line_level_1_reflected.363e59d2.svg";